import {
  FETCH_VERIFY,
  FETCH_VERIFY_FAILED,
  FETCH_VERIFY_SUCCESS
} from '../../types';

const initialState = {
  user: {},
  isLoading: false,
  errors: {},
  error: false
}


const fetchUserVerifyReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VERIFY:
      return {
        ...state,
        isLoading: true,
          user: action.payload
      }
      case FETCH_VERIFY_SUCCESS:
        return {
          ...state,
          isLoading: false,
            user: action.payload
        }
        case FETCH_VERIFY_FAILED:
          return {
            ...state,
            isLoading: false,
              errors: action.payload,
              error: true
          }
          default:
            return {
              ...state
            };
  }
}

export default fetchUserVerifyReducer;
